import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'

import { TextInput, Button } from 'ui/components'
import ButtonPlanList from 'ui/components/plan/ButtonPlanList'

import messages from 'utils/messages'
import { extractOnlyNumbers } from 'utils/functions'

import Container from './styles'

const validationSchema = Yup.object({
  docNumber: Yup.string().required(messages.required),
})

const initialValues = {
  docNumber: '',
}

export default ({
  btnMainText,
  btnConfirmText,
  onConfirm,
  onCancel,
  showBtnPlanList = false,
}) => {
  const panelEnv = useSelector(state => state.auth.panelEnv)
  const orgUsePlan = useSelector(state => state.organization.config.use_plan)

  const [formShow, setFormShow] = useState(false)
  const [planSelected, setPlanSelected] = useState(null)

  const handleCancel = () => {
    setFormShow(false)
    if (onCancel) onCancel()
  }

  const handleSubmit = (values) => {
    setFormShow(false)
    const data = {
      docNumber: extractOnlyNumbers(values.docNumber),
    }
    if (showBtnPlanList && planSelected) data.planId = planSelected.plan_id

    if (onConfirm) onConfirm(data)
  }

  const handlePlanSelected = (plan) => {
    setPlanSelected(plan)
  }

  const renderBtnPlanList = () => {
    if (!showBtnPlanList) return null

    return (
      <ButtonPlanList
        disabled={orgUsePlan}
        docType={panelEnv}
        onSelectPlan={handlePlanSelected}
        showBtnCreate={false}
        showBtnDelete={false}
        showBtnEdit={false}
        showBtnSelect={true}
        showBtnView={true}
      />
    )
  }

  const renderPlanReadOnly = () => {
    if (!orgUsePlan) return null

    return <span>A configurãção definida na sua organização não permite alterar o plano!</span>
  }

  const renderForm = () => {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(form) => {
          return (
            <form onSubmit={form.handleSubmit}>
              <Field
                name="docNumber"
                label={`${panelEnv.toUpperCase()} *`}
                mask={panelEnv}
                component={TextInput}
              />

              {renderBtnPlanList()}
              {renderPlanReadOnly()}

              <div className="buttons-container">
                <Button
                  onClick={handleCancel}
                  variant="text"
                >
                  Cancelar
                </Button>
                <Button type="submit">
                  {btnConfirmText}
                </Button>
              </div>
            </form>
          )
        }}
      </Formik>
    )
  }

  return (
    <Container>
      {!formShow ? (
        <Button
          className="primary button-request"
          onClick={() => setFormShow(true)}
        >
          {btnMainText}
        </Button>
      ) : (
        renderForm()
      )}
    </Container>
  )
}
